import React, { useState, useEffect } from "react";
import { FaPlus } from 'react-icons/fa';
import { FiTrash2 } from "react-icons/fi";
import Header from '../components/Admin/Header'; 
import Sidebar from '../components/Admin/Sidebar'; 
import { Link } from 'react-router-dom'; 
import { $host } from "../http";

const SubjectPage = () => {
  const [subjects, setSubjects] = useState([]);
  const [newSubjectTitle, setNewSubjectTitle] = useState("");
  const [newSubjectDescription, setNewSubjectDescription] = useState("");
  const [isAddingSubject, setIsAddingSubject] = useState(false);

  const fetchSubjects = async () => {
    try {
      const response = await $host.get("/api/public/subjects");
      setSubjects(response.data);
    } catch (error) {
      console.error("Ошибка загрузки предметов:", error);
    }
  };

  const handleAddSubject = async () => {
    if (!newSubjectTitle || !newSubjectDescription) {
      alert("Пожалуйста, введите название и описание предмета.");
      return;
    }

    try {
      await $host.request("/api/admin/subjects/create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({ title: newSubjectTitle, description: newSubjectDescription }),
      });

      await fetchSubjects(); // Обновляем список после добавления
      setNewSubjectTitle("");
      setNewSubjectDescription("");
      setIsAddingSubject(false);
    } catch (error) {
      console.error('Ошибка:', error);
    }
  };

  const handleDeleteSubject = async (subjectId) => {
    try {
      await $host.delete(`/api/admin/subjects/${subjectId}`);

      setSubjects(subjects.filter((subject) => subject.id !== subjectId));
      await fetchSubjects(); // Обновляем список после добавления
      
    } catch (error) {
      console.error('Ошибка:', error);
    }
  };

  useEffect(() => {
    fetchSubjects();
  }, []);

  return (
    <div>
      <Header />
      <div className="flex min-h-screen bg-gray-100">
        <Sidebar />
        <main className="flex-1 p-8 bg-[#F3F1FB4D]">
          <nav className="w-full rounded-md mb-8">
            <ol className="list-reset flex">
              <li>
                <Link to="/admin/subjects" className="text-black ">Предметы</Link>
              </li>
              <li>
                <span className="mx-2 text-neutral-400">/</span>
              </li>
              <li className="text-neutral-400">Всего {subjects ? subjects.length : 0} предметов</li>
            </ol>
          </nav>

          <div className="flex mb-4">
            <button
              onClick={() => setIsAddingSubject(true)} // Показываем блок добавления
              className="w-full bg-[#6446C314] hover:bg-[#6446C31F] text-[#6446C3] font-semibold py-4 px-6 rounded-lg transition-colors flex items-center justify-center"
              aria-label="Add Subject"
            >
              <FaPlus className="text-1xl" />
            </button>
          </div>

          

          <div className="bg-white rounded-lg shadow-lg p-6" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
            <h1 className="text-2xl font-bold text-gray-800 mb-4">Предметы</h1>
            {isAddingSubject && ( // Условное отображение блока для добавления

            <div className="flex flex-col mb-4 p-4 bg-[#6446C314] rounded-lg">
                <input
                  type="text"
                  value={newSubjectTitle}
                  onChange={(e) => setNewSubjectTitle(e.target.value)}
                  placeholder="Введите название предмета"
                  className="pl-0 flex-1 bg-transparent border border-[#6446C3] rounded-[8px] text-[#6446C3] placeholder-[#6446C399] p-2"
                />
                <div className="w-[100%] h-[0.5px] bg-[#6446C3]"></div>
                <input
                  value={newSubjectDescription}
                  onChange={(e) => setNewSubjectDescription(e.target.value)}
                  placeholder="Введите описание предмета"
                  className="pl-0 flex-1 bg-transparent border border-[#6446C3] rounded-[8px] text-[#6446C3] placeholder-[#6446C399] p-2"
                />
                <button
                  onClick={handleAddSubject}
                  className="mt-2 p-2 text-gray-600 hover:text-[#6446C3] rounded-[8px]"
                  aria-label="Добавить предмет"
                >
                  <span className="text-grey-700 font-medium">Добавить</span> 
                </button>
              </div>
 )}
            <div className="space-y-4">
              {subjects && subjects.map((subject) => (
                <div key={subject.id} className="flex items-center justify-between p-4 bg-[#6446C314] rounded-lg">
                  <span className="font-bold text-[#6446C3]">{subject.title}</span>
                  <button 
                    onClick={() => handleDeleteSubject(subject.id)}
                    className="p-2 text-gray-600 hover:text-red-600 rounded-[8px]"
                    aria-label="Удалить предмет"
                  >
                    <FiTrash2 />
                  </button>
                </div>
              ))}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default SubjectPage;
